<div class="enable-authenticator-content">
  <div class="icon-container">
    <img src="assets/icon/input-pin.svg" alt="Input Password" class="password-icon" />
  </div>

  <div class="enable-header">
    <h2>Enable Authenticator App</h2>
    <p>Add an extra layer of security to your account by enabling an Authenticator app.</p>
  </div>

  <div class="enable-buttons">
    <lib-button type="Secondary" (click)="laterEnableAuthenticator()" label="Later" width="120px">
    </lib-button>
    <lib-button type="Primary" (click)="setupAuthenticator()" width="120px" label="Set Up">
    </lib-button>
  </div>
</div>
